import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import AboutComponent, { StyledP } from
  '@fuww/library/src/Articles/Sections/About';
import { BaseGrid, GridCell } from '@fuww/library/src/Grid';
import Button from '@fuww/library/src/Button';
import LinkAndAnchor from '../../LinkAndAnchor';
import messages from '../../../lib/messages.json';

const Description = ({ description }) => (
  <BaseGrid>
    {description.rows.map(({ id, paragraphs }) => (
      <GridCell key={id} md={6}>
        {paragraphs.map(({ id: paragraphId, text }) => (
          <StyledP key={paragraphId}>
            {text}
          </StyledP>
        ))}
      </GridCell>
    ))}
  </BaseGrid>
);

Description.propTypes = {
  description: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      paragraphs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        text: PropTypes.string,
      })),
    })).isRequired,
  }).isRequired,
};

const CallToAction = ({ intl }) => (
  <>
    <Button
      variant="contained"
      href={intl.formatMessage(messages['newsletterCategory.href'], {
        category: 'education',
      })}
      className="education-newsletter-signup"
      role="link"
    >
      {intl.formatMessage(messages.signup)}
    </Button>
    <Button
      href="/rss-education"
      role="link"
    >
      {intl.formatMessage(messages.rssFeed)}
    </Button>
  </>
);

CallToAction.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

const About = ({
  title,
  description,
  contactTitle,
  email,
  telephone,
}) => {
  const intl = useIntl();

  return (
    <AboutComponent
      title={title}
      description={<Description description={description} />}
      contactTitle={contactTitle}
      email={(
        <LinkAndAnchor href={`mailto:${email}`}>{email}</LinkAndAnchor>
      )}
      telephone={(
        <LinkAndAnchor href={`tel:${telephone}`}>
          {telephone}
        </LinkAndAnchor>
      )}
      callToAction={<CallToAction intl={intl} />}
    />
  );
};

About.propTypes = {
  title: PropTypes.string,
  description: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      paragraphs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        text: PropTypes.string,
      })),
    })),
  }),
  contactTitle: PropTypes.string,
  email: PropTypes.string,
  telephone: PropTypes.string,
};

About.defaultProps = {
  title: null,
  description: null,
  contactTitle: null,
  email: null,
  telephone: null,
};

export default About;
